import { CommonWidgetConfig } from '../../models';
import { WidgetDetails } from '../models';
import EditForm from './EditForm';
import Widget from './Widget';

export type Config = CommonWidgetConfig & { type: "command2" };

export const details: WidgetDetails = {
    type: "command2",
    name: "Command Widget"
  }
  
  export { EditForm, Widget };

